import * as types from '../actions/types'
import { AUTH_ERROR_MESSAGES } from '../utils/const'

const initialState = {
  url: '/token/sso',
  ssoAuth: null
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case types.IS_BASIC_LOGIN_ALLOWED:
      return {
        ...state,
        allowBasicLogin: action.allowBasicLogin,
        error: action.allowBasicLogin ? null : AUTH_ERROR_MESSAGES[401],
      }
    case types.AUTH_COMPLETED:
      return {
        ...state,
        ...action.user,
        error: null,
      }
    case types.AUTH_FAILED:
      return {
        ...initialState,
        error: action.error,
        url: state.url,
      }
    case types.SIGNED_OUT:
      return {
        ...initialState,
        url: state.url,
      }
    case types.SSO_IS_NOT_IMPLEMENTED:
      return {
        ...state,
        url: '/token',
        error: null,
      }
    case types.AUTH_ERROR_MODAL_CLOSED:
      return {
        ...state,
        error: null,
      }
    case types.SET_SSO_AUTH_STATE:
      return {
        ...state,
        ssoAuth: action.payload
      }
    default:
      return state
  }
}
